import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import EmployeeImport from "./EmployeeImport";
import UserImport from "./UserImport";
import DataSettingImport from "./DataSettingImport";
import { useLocation, useSearchParams } from "react-router-dom";
import { DEFAULT_IMPORT_TAB, IMPORT_TABS } from "./importNavigation";
import { useTranslation } from "translation/useTranslation";

function Tabs({ activeTab, handleChangeTab }) {
  const { editableTranslate } = useTranslation();

  return <div className="employee-management-tabs">
    <div className={`cursor-pointer ${activeTab === 'employees' ? 'active' : ''}`} onClick={() => handleChangeTab('employees')} data-testid="import-tab-employees">
      <span>{editableTranslate('import.tabs.employees', 'Beschäftigte')}</span>
    </div>
    <div className={`cursor-pointer ${activeTab === 'login_users' ? 'active' : ''}`} onClick={() => handleChangeTab('login_users')} data-testid="import-tab-login-users">
      <span>{editableTranslate('import.tabs.login_users', 'Nutzende')}</span>
    </div>
    <div className={`cursor-pointer ${activeTab === 'extensions' ? 'active' : ''}`} onClick={() => handleChangeTab('extensions')} data-testid="import-tab-extensions">
      <span>{editableTranslate('import.tabs.extensions', 'Erweiterungen')}</span>
    </div>
  </div>;
}

export default function Import() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [counter, setCounter] = useState(0);

  const activeTab = useMemo(() => {
    const currentTab = searchParams.get("tab");
    return Object.values(IMPORT_TABS).includes(currentTab) ? currentTab : DEFAULT_IMPORT_TAB;
  }, [searchParams]);

  const handleChangeTab = (target) => {
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set("tab", target);
    nextSearchParams.delete("page");
    nextSearchParams.delete("per_page");
    setSearchParams(nextSearchParams);
    setCounter(prev => prev + 1);
  };

  useEffect(() => {
    setCounter(prev => prev + 1);
  }, [location]);

  return (
    <>
      {
        activeTab === 'employees' && <EmployeeImport tabsComponent={<Tabs activeTab={activeTab} handleChangeTab={handleChangeTab} />} counter={counter} />
      }
      {
        activeTab === 'login_users' && <UserImport tabsComponent={<Tabs activeTab={activeTab} handleChangeTab={handleChangeTab} />} counter={counter} />
      }
      {
        activeTab === 'extensions' && <DataSettingImport tabsComponent={<Tabs activeTab={activeTab} handleChangeTab={handleChangeTab} />} />
      }
    </>
  );
}
